import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'folder/Inbox',
  //   pathMatch: 'full'
  // },
  { path: "", redirectTo: "", pathMatch: "full" },

  {
    path: "tabs",
    loadChildren: () =>
      import("./tabs/tabs.module").then((m) => m.TabsPageModule),
  },
  {
    path: "home",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "tabs",
    loadChildren: () =>
      import("./tabs/tabs.module").then((m) => m.TabsPageModule),
  },
  {
    path: "folder/:id",
    loadChildren: () =>
      import("./folder/folder.module").then((m) => m.FolderPageModule),
  },

  {
    path: "appointment-form",
    loadChildren: () =>
      import("./appointment-form/appointment-form.module").then(
        (m) => m.AppointmentFormPageModule
      ),
  },
  {
    path: "notification",
    loadChildren: () =>
      import("./notification/notification.module").then(
        (m) => m.NotificationPageModule
      ),
  },
  {
    path: "profile",
    loadChildren: () =>
      import("./profile/profile.module").then((m) => m.ProfilePageModule),
  },
  {
    path: "setting",
    loadChildren: () =>
      import("./setting/setting.module").then((m) => m.SettingPageModule),
  },

  {
    path: "privacypolicy",
    loadChildren: () =>
      import("./privacypolicy/privacypolicy.module").then(
        (m) => m.PrivacypolicyPageModule
      ),
  },
  {
    path: "terms",
    loadChildren: () =>
      import("./terms/terms.module").then((m) => m.TermsPageModule),
  },
  {
    path: "about-us",
    loadChildren: () =>
      import("./about-us/about-us.module").then((m) => m.AboutUsPageModule),
  },
  {
    path: "filter",
    loadChildren: () =>
      import("./filter/filter.module").then((m) => m.FilterPageModule),
  },
  {
    path: "register",
    loadChildren: () =>
      import("./register/register.module").then((m) => m.RegisterPageModule),
  },
  {
    path: "all-appointments",
    loadChildren: () =>
      import("./all-appointments/all-appointments.module").then(
        (m) => m.AllAppointmentsPageModule
      ),
  },
  {
    path: "video-call-screen/:price",
    loadChildren: () =>
      import("./video-call-screen/video-call-screen.module").then(
        (m) => m.VideoCallScreenPageModule
      ),
  },
  {
    path: "all-slots/:appointId/:docID/:firstname/:lastname/:phone",
    loadChildren: () =>
      import("./all-slots/all-slots.module").then((m) => m.AllSlotsPageModule),
  },
  {
    path: "all-slots",
    loadChildren: () =>
      import("./all-slots/all-slots.module").then((m) => m.AllSlotsPageModule),
  },
  {
    path: "forgot-pass",
    loadChildren: () =>
      import("./forgot-pass/forgot-pass.module").then(
        (m) => m.ForgotPassPageModule
      ),
  },
  {
    path: "support",
    loadChildren: () =>
      import("./support/support.module").then((m) => m.SupportPageModule),
  },
  {
    path: "check-otp",
    loadChildren: () =>
      import("./check-otp/check-otp.module").then((m) => m.CheckOTPPageModule),
  },
  {
    path: "register-otp",
    loadChildren: () =>
      import("./register-otp/register-otp.module").then(
        (m) => m.RegisterOTPPageModule
      ),
  },
  {
    path: "doctorprofile",
    loadChildren: () =>
      import("./doctorprofile/doctorprofile.module").then(
        (m) => m.DoctorprofilePageModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
